import { render, staticRenderFns } from "./OfferingCardTokenChip.vue?vue&type=template&id=7fa90331&scoped=true"
import script from "./OfferingCardTokenChip.vue?vue&type=script&lang=ts"
export * from "./OfferingCardTokenChip.vue?vue&type=script&lang=ts"
import style0 from "./OfferingCardTokenChip.vue?vue&type=style&index=0&id=7fa90331&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa90331",
  null
  
)

export default component.exports